import { PlainModal } from '@/components/modals/plain-modal';
import { TextLink } from '@/components/text-link';
import { joinSgcmSite } from '@/utils/url/join/public';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const TotalBasicCostModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerTotalBasicCostModal}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      The total basic cost is the amount the dealer paid for to import and
      register the vehicle in Singapore. It includes the OMV, custom duty,
      GST, ARF, VES rebate/surcharge, registration fees and COE.
    </div>
    <div>
      The total basic cost excludes insurance premium, number plates,
      road tax, IU, dealer&apos;s commission, and all other overheads. The
      formula used to derive the figure is as follows:
    </div>
    <div className={styles.textIsBold}>
      Total Basic Cost =
      OMV + Custom duty + GST + ARF + Registration fee + COE + VES surcharge.
    </div>
    <div>
      Where:
      <br />
      Custom duty = 20% x OMV
      <br />
      GST = 9% x (OMV + Custom duty)
      <br />
      Registration fee = $220
    </div>
    <div>
      For more information on total basic cost, please click
      <TextLink
        className={styles.textLink}
        href={`${joinSgcmSite('/articles/advice/car-buying-in-singapore-what-you-are-actually-paying-for-30527')}`}
        text=" here" />
      .
    </div>
    <div>
      Take note that in cases whereby the dealer is not the importer of the
      vehicle, the actual cost price of the car to the dealer will be
      significantly higher than the total basic cost.
    </div>
  </PlainModal>
);
